var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"at-wrap",class:`at--${_vm.position}`},[_c('span',{staticClass:"at-slot",class:{ 'at-slot--truncate': _vm.truncate }},[_vm._t("default")],2),_c('span',{staticClass:"at-box",style:(_vm.minWidth ? { minWidth: _vm.minWidth, whiteSpace: 'normal', wordBreak: 'break-word' } : {})},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }